<template>
  <div :class="{'input-icon': icon}">
    <input
      ref="input"
      :class="[statusType, size, {'is-big': isBig}]"
      :type="newType"
      :autocomplete="newAutocomplete"
      :value="newValue"
      :maxlength="maxlength"
      v-bind="$attrs"
      class="input"
      @input="input"
      @blur="$emit('blur', $event) && checkHtml5Validity()"
      @focus="$emit('focus', $event)">
    <svg-icon :name="icon"></svg-icon>
  </div>
</template>

<script>

import BuefyInput from 'buefy/src/components/input/Input.vue';
export default {
  extends: BuefyInput,
  props: {
    isBig: Boolean
  }
};
</script>

<style lang="scss" scoped>
.input:not(.is-big) {
  box-shadow: none;
  height: 36px;
}
.svg-icon {
  position: absolute;
  top: 10px;
  left: 10px;
}
.input-icon {
  input {
    padding-left: 32px;
  }
}
</style>
